import { Globe } from 'lucide-react';

interface AgentInternetAccessBadgeProps {
    hasInternetAccess: boolean;
}

export function AgentInternetAccessBadge({
    hasInternetAccess
}: AgentInternetAccessBadgeProps) {
    if (!hasInternetAccess) return null;

    return (
        <div className="flex items-center gap-1.5 bg-blue-50 dark:bg-blue-950/40 p-1.5 pr-3 pl-2 border border-blue-100 dark:border-blue-900 border-rounded rounded-full w-fit font-medium text-xs">
            <Globe strokeWidth={1.5} className="size-4! text-blue-950 dark:text-blue-200" />
            <span className="text-blue-950/80 dark:text-blue-200/80">Internet access</span>
        </div>
    );
}
